import { Injectable } from '@angular/core';
import  Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalService {

  constructor() { }

  homeFireSuccessSwal(message: string){
      return Swal.fire({
      title: message,
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    })
  }
  fireSuccessSwal(message: string, protocolo:string){
      return Swal.fire({
      title: message,
      text: protocolo,
      icon: 'success',
      confirmButtonText: 'OK',
      confirmButtonColor: 'var(--main-blue)',
      allowEscapeKey:false,
      allowOutsideClick:false
    })
  }
  fireErrorSwal(title:string, message: string){
      return Swal.fire({
      title: title,
      text: message,
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: 'var(--main-blue)',

    })
  }
}
